import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=aa2d11ee&scoped=true&lang=pug"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=aa2d11ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d11ee",
  null
  
)

export default component.exports